import { useState } from 'react';

// Custom hook
export function useInvoiceDetails() {
    const [providerEmail, setProviderEmail] = useState('');

    return [providerEmail, setProviderEmail];
}
